"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlag = useFlag;
const utils_1 = require("../utils");
const use_flags_context_hook_1 = require("./use-flags-context.hook");
function useFlag(input) {
    const context = (0, use_flags_context_hook_1.useFlagsContext)();
    const flag = context?.flags[input.flagName] || (0, utils_1.fallbackFlag)(input.flagName);
    if (input.variant) {
        context?.onFlagRender(flag, flag.variant.name);
        return flag.variant;
    }
    context?.onFlagRender(flag);
    return flag?.enabled;
}
//# sourceMappingURL=use-flag.hook.js.map